/*import React, { Component } from 'react'
import {
  ShareButtons,
  ShareCounts,
  generateShareIcon
} from 'react-share';

const {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  RedditShareButton,
} = ShareButtons;

const {
  FacebookShareCount,
  GooglePlusShareCount,
  LinkedinShareCount,
  PinterestShareCount,
  VKShareCount,
  OKShareCount,
  RedditShareCount,
} = ShareCounts;

const shareUrl = 'http://www.kfsyscc.org'

const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const TelegramIcon = generateShareIcon('telegram');
const WhatsappIcon = generateShareIcon('whatsapp');
const GooglePlusIcon = generateShareIcon('google');
const LinkedinIcon = generateShareIcon('linkedin');
const PinterestIcon = generateShareIcon('pinterest');
const VKIcon = generateShareIcon('vk');
const OKIcon = generateShareIcon('ok');
const RedditIcon = generateShareIcon('reddit');

export default class ShareObj extends Component {
  render() {
    console.log(window.location.href);
    return (
      <div style={{position:'fixed',bottom:'2',zIndex:'50'}}>
        <FacebookShareButton url={window.location.href}>
          <FacebookIcon size={36} round={true} />
        </FacebookShareButton>
      </div>
    )
  }
}*/

import React, { Component } from 'react';
import ShareBtn from 'react-share-button';
import docstorsStore from '../stores/doctors';
import ShareIcon from 'material-ui/svg-icons/social/share'

export default class ShareObj extends Component {
  render() {
    return (
      <div style={{ backgroundColor: 'rgba(225,225,225,0.6)', borderRadius: '5px', padding: '5px' }}>
        <ShareBtn
          displayText='分享'
          url={window.location.href}
          text={`${docstorsStore.DocDetail.NameCh} 醫師`}
          className='ib'
        >
        </ShareBtn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Share.js